import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MatListModule } from '@angular/material';
import { RouterModule, Routes } from "@angular/router";
import { BreadcrumbModule } from '../components/breadcrumb/breadcrumb.module';
import { TagsInputModule } from '../components/tags-input/tags-input.module';
import { PaginatorComponentModule } from '../components/paginator/paginator.component.module';
import { FilterButtonModule } from "../components/filter-button/filter-button.module";
import { MatTooltipModule } from "@angular/material";
import { ExpeditionCollectedComponent } from './expedition-collected.component';
import {MatTabsModule} from '@angular/material/tabs';
import { PackageCollectedModule } from './package-collected/package-collected.module';

import {
  MatCheckboxModule,
  MatPaginatorModule,
  MatRippleModule,
  MatSortModule,
  MatTableModule
} from '@angular/material';
import { NgxFileDropModule } from  'ngx-file-drop' ;
import { PackageCollectedComponent } from './package-collected/package-collected.component';
import {PackagesComponent} from "../expedition-collected/packages/packages.component";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {PackagesWarningCancelledComponent} from "./packages-warning-cancelled/packages-warning-cancelled.component";
const routes: Routes = [
  {
    path: '',
    component: ExpeditionCollectedComponent
  }
];



@NgModule({
  entryComponents:[PackageCollectedComponent, PackagesComponent, PackagesWarningCancelledComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
    BreadcrumbModule,
    RouterModule.forChild(routes),
    TagsInputModule,
    PaginatorComponentModule,
    FilterButtonModule,
    MatTooltipModule,
    FormsModule,
    MatCheckboxModule,
    MatRippleModule,
    MatSortModule,
    NgxFileDropModule,
    MatTabsModule,
    PackageCollectedModule,
    MatButtonModule,
    MatIconModule
  ],
  declarations: [ExpeditionCollectedComponent, PackagesComponent, PackagesWarningCancelledComponent]
})
export class ExpeditionCollectedModule { }
